module.exports = __webpack_public_path__ + "img/news2.7c3a9c23.png";